// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1Kma1","searchAndBtn":"searchAndBtn--2Ayju","search":"search--ohrBs","create_btn":"create_btn--1VYh1","list":"list--37myp"};